import { render } from "./BottomMenu.vue?vue&type=template&id=f413c09c"
import script from "./BottomMenu.vue?vue&type=script&lang=js"
export * from "./BottomMenu.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./BottomMenu.vue?vue&type=style&index=0&id=f413c09c&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/musubisumu/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__